module.exports = __webpack_public_path__ + "img/个人简历图标-工作成就-2.e69599da.png";